import styled from 'styled-components';

export const Thead = styled.thead`
  background: #f2f2f2;
`;

export const Td = styled.td`
  border: 1px solid #e3e3e3;
  text-align: center;
`;

export const Tr = styled.tr`
  position: relative;
  border: 1px solid #e3e3e3;
  position: relative;
`;

export const Th = styled.th`
  text-align: center;
  background: #4b286d;
  color: #fff;
  font-weight: 700;
`;

export const ServiceNameContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Label = styled.p`
  color: ${prop => (prop.isDisabled ? '#adadad' : '#222')};
  line-height: normal;
`;
export const Input = styled.input`
  background-color: ${prop =>
    prop.isDisabled ? '#f7f7f7' : '#fff'} !important;
  color: ${prop => (prop.isDisabled ? '#cdcdcd' : '#222')} !important;
`;

export const MaximunQuantityNote = styled.p`
  font-size: 13px;
  color: #999;
  margin-top: 5px;
  font-weight: 600;
`;

export const DisabledOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  // background-color: rgba(0, 0, 0, 0.2);
  z-index: 1;
`;
